module.exports = __webpack_public_path__ + "img/slide_p5.78cb359b.png";